import { num } from '../lib/format'
/**
 * Donut met legenda, opgebouwd met een conic-gradient — dezelfde techniek en
 * classes als de stijlreferentie, dus geen chart-bibliotheek nodig.
 */
export function Donut({
  title,
  segments,
}: {
  title: string
  segments: { label: string; value: number; color: string }[]
}) {
  const total = segments.reduce((a, s) => a + s.value, 0)
  let acc = 0
  const stops = segments
    .map((s) => {
      const from = (acc / (total || 1)) * 100
      acc += s.value
      const to = (acc / (total || 1)) * 100
      return `${s.color} ${from}% ${to}%`
    })
    .join(',')

  return (
    <div className="row" style={{ gap: 20 }}>
      <div
        className="donut"
        style={{ background: total ? `conic-gradient(${stops})` : 'var(--panel3)' }}
      >
        <div className="hole">
          <div>
            <b style={{ fontSize: 18 }}>{num(total)}</b>
            <div className="mut2" style={{ fontSize: 12 }}>{title}</div>
          </div>
        </div>
      </div>
      <div className="legend">
        {segments.map((s) => (
          <div className="li" key={s.label}>
            <span className="sw" style={{ background: s.color }} />
            {s.label || 'unknown'}
            <b style={{ marginLeft: 'auto' }}>{num(s.value)}</b>
          </div>
        ))}
      </div>
    </div>
  )
}
